import { render, staticRenderFns } from "./FacilityInfo.vue?vue&type=template&id=2b036d3a&"
import script from "./FacilityInfo.vue?vue&type=script&lang=ts&"
export * from "./FacilityInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports